const HTML_ESCAPE_MAP: Readonly<Record<string, string>> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/**
 * Escapes the HTML special characters in a string so it can be safely
 * substituted into markup that is later rendered through `innerHTML`.
 *
 * Use this for every value that originates from the client (file names, free
 * text input, query parameters) before it is interpolated into a
 * CMS-provided message template.
 *
 * @example
 * ```ts
 * escapeHtml('xss<img src=x onerror="alert(1)">.exe');
 * // 'xss&lt;img src=x onerror=&quot;alert(1)&quot;&gt;.exe'
 * ```
 * @param value - The untrusted string.
 * @returns The string with `&`, `<`, `>`, `"` and `'` replaced by HTML entities.
 */
export const escapeHtml = (value: string): string =>
  'string' === typeof value
    ? value.replace(/[&<>"']/g, (character: string): string => HTML_ESCAPE_MAP[character])
    : value;
